import { useSelector } from 'react-redux';
import { SharedStoreState } from '../types';

export const chatbotSelector = (state: SharedStoreState) => state.chatbot;

export const useSelectChatbot = () => useSelector(chatbotSelector);
